import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, DESKTOP_VIDEO_ADHESION_AD_FIELDS } from "./definitions";
import DropdownSection from "./DropdownSection";
import InputTextSection from "./InputTextSection";
import VideoAssetCreativeType from "./VideoAssetCreativeType";
import BaseCreativeControls from "./BaseCreativeControls";

const CREATIVE_TYPE = CREATIVE_NAMES.DESKTOP_VIDEO_ADHESION;

const COLLAPSE_AD_OPTIONS = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

export default function DesktopVideoAdhesion({
    collapsibleVideoUrl,
    collapsibleDesktopImageUrl,
    collapseDelay,
    autoCollapseAd,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    videoCreativeType,
    vastUrl,
    vastDuration,
    adServingType,
    poster
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <VideoAssetCreativeType
                    dropdownLabel="Video Creative Type"
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={DESKTOP_VIDEO_ADHESION_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType || 'video'}
                    handleChange={handleChange}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel="Video URL"
                    videoUrlInputName={DESKTOP_VIDEO_ADHESION_AD_FIELDS.collapsibleVideoUrl}
                    videoUrl={collapsibleVideoUrl}
                    vastInputName={DESKTOP_VIDEO_ADHESION_AD_FIELDS.vastUrl}
                    vastUrl={vastUrl}
                    vastDurationInputName={DESKTOP_VIDEO_ADHESION_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />

                <AssetInputOrUploadSection
                    inputValue={collapsibleDesktopImageUrl}
                    inputLabel="Creative banner (970x250px)"
                    inputName={DESKTOP_VIDEO_ADHESION_AD_FIELDS.collapsibleDesktopImageUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <AssetInputOrUploadSection
                    inputValue={poster}
                    inputLabel="Video Poster Image (4:3 ratio image e.g ~888x500px)"
                    inputName={DESKTOP_VIDEO_ADHESION_AD_FIELDS.poster}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <DropdownSection
                    label="Autocollapse Ad"
                    name={DESKTOP_VIDEO_ADHESION_AD_FIELDS.autoCollapseAd}
                    value={autoCollapseAd}
                    options={COLLAPSE_AD_OPTIONS}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
                {autoCollapseAd &&
                    (
                        <InputTextSection
                            label={"Collapse delay"}
                            name={DESKTOP_VIDEO_ADHESION_AD_FIELDS.collapseDelay}
                            value={collapseDelay}
                            changeHandler={handleChange}
                            adtype={CREATIVE_TYPE}
                            required={false}
                        />
                    )
                }
            </BaseCreativeControls>
        </>
    );
}
